import * as React from "react";

function SvgReturnSolid(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5 2h-15A2.502 2.502 0 002 4.5v11.25c0 1.379 1.121 2.5 2.5 2.5h3.75v3.281a.467.467 0 00.746.375l4.879-3.656H19.5c1.379 0 2.5-1.121 2.5-2.5V4.5C22 3.121 20.879 2 19.5 2zM12 16c.827 0 1.5-.7 1.5-1.563 0-.861-.673-1.562-1.5-1.562s-1.5.7-1.5 1.563c0 .861.673 1.562 1.5 1.562zm-1.071-4.195l-.255-5.313a.46.46 0 01.45-.492h1.753a.46.46 0 01.45.492l-.256 5.313a.459.459 0 01-.45.445h-1.243a.459.459 0 01-.45-.445z"
        fill="currentColor"
      />
    </svg>
  );
}

const ForwardRef = React.forwardRef(SvgReturnSolid);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
